var map = {
	"./images/student-snapshort1-01.png": 290,
	"./images/student-snapshort1-frame.png": 291,
	"./images/student-snapshort1-level.png": 292,
	"./images/student-snapshort1-line.png": 293,
	"./images/student-snapshort1-logout.png": 294,
	"./images/student-snapshort1-matching.png": 295,
	"./images/student-snapshort1-next.png": 296,
	"./images/student-snapshort1-photo.png": 297,
	"./images/student-snapshort1-point.png": 298,
	"./images/student-snapshort1-score.png": 299,
	"./images/student-snapshort1-watch.png": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 289;